export default "__VITE_ASSET__C8fOsSZ$__"